// Color palette and configuration constants
export const colors = {
  searchSystemFill: '#f7a600',
  searchSystemStroke: '#000000',
  searchSystemStrokeWidth: '1px',
  searchSystemFillLowLiquid: '#fcb6b6',
  searchSystemFillLiquid: '#ff0000',
  searchSystemFillLowGaseous: '#a2defc',
  searchSystemFillGaseous: '#009eed',
  searchSystemFillLowMineral: '#cefab9',
  searchSystemFillMineral: '#3fbf00',
  systemFill: '#f7a600',
  systemStroke: '#000000',
  pathStroke: '#f7a600',
  pathStrokeWidth: '2px',
  resetSystemFill: '#cccccc',
  resetSystemStroke: '#000000',
  resetSystemFillOpacity: 0.8,
  resetSystemStrokeWidth: '1px',
  resetPathStroke: '#6e7980',
  resetPathStrokeWidth: '1px'
};
